import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledProPhotoGrid} from '@/features/service-vetting/components/service-pro-photos-grid/style'

export const StyledProPhotosHeader = styled(Flexbox)(
    ({theme: {spacing, palette, typography}}) => css`
        padding-top: ${spacing * 10}px;
        padding-bottom: ${spacing * 6}px;
        & h1 {
            color: ${palette.neutral['900']};
            ${typography.textLg};
            font-weight: 500;
        }
        & p {
            color: ${palette.neutral['700']};
            ${typography.textMd};
        }
    `
)

export const StyledProPhotosTitleWrapper = styled(Flexbox)(
    ({theme: {typography, palette}}) => css`
        min-height: 70px;
        & h3 {
            color: ${palette.neutral['900']};
            ${typography.textMd};
            font-weight: 500;
        }

        & span {
            ${typography.textSm};
        }
    `
)

export const StyledProPhotosSkeletonGrid = styled(StyledProPhotoGrid)(
    ({theme: {spacing}}) => css`
        gap: ${spacing * 10}px;
        padding: ${spacing * 5}px;
    `
)

export const StyledProPhotosServicesSkeletonGrid = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        margin: ${spacing * 5}px 0;
        width: 100%;
    `
)
